// const BASE_URL = "https://vclive.prod-rasiinfotech.in";
const BASE_URL = "https://billing.eswarjewellers.com";

// const BASE_URL = "https://zinger.prod-rasiinfotech.in";
const WEB_URL  = "https://eswarjewellers.com";

// const BASE_URL = "https://froads.trysumangaleejewellers.in";


export { BASE_URL , WEB_URL};
